$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('scenario-rv-video')) {
    customElements.define(
      'scenario-rv-video',
      class ScenarioRvVideo extends HTMLElement {
        swiper = null;
        constructor() {
          super();
          window.litime.ModalControllerState = window.litime.ModalControllerState || new ModalController();
          this.modalManager = window.litime.ModalControllerState;
        }

        connectedCallback() {
          this.init();
        }

        init() {
          const $root = $(this);
          const _this = this;
          const $videoItems = $root.find('.video_item');
          $videoItems.on('click', function (event) {
            _this.handlePlayClick(event);
          });

          const $mySwiper = this.querySelector('.scenario-rv-video_swiper');
          const $scrollbarDom = this.querySelector('.scenario-rv-video-scrollbar');
          const $prevDom = this.querySelector('.scenario-rv-video_prev');
          const $nextDom = this.querySelector('.scenario-rv-video_next');

          this.swiper = new Swiper($mySwiper, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            slidesPerGroup: 1,
            navigation: {
              nextEl: $nextDom,
              prevEl: $prevDom,
            },
            scrollbar: {
              el: $scrollbarDom,
              draggable: true,
            },
            breakpoints: {
              1201: {
                slidesPerGroup: 4,
              },
            },
            on: {
              init: function () {
                _this._toggleNav(this, $prevDom, $nextDom);
              },
              slideChange: function () {
                _this._toggleNav(this, $prevDom, $nextDom);
              },
            },
          });
        }

        _toggleNav(swiper, prevEl, nextEl) {
          if (!prevEl || !nextEl) return;
          prevEl.classList.toggle('is-hidden', swiper.isBeginning);
          nextEl.classList.toggle('is-hidden', swiper.isEnd);
        }

        handlePlayClick(event) {
          const $video = $(event.currentTarget);
          const modalId = $video.data('id');
          if (!this.modalManager.getModal(modalId)) {
            this.modalManager.register(modalId, {
              onOpen: (container) => {
                const iframe = $(container).find('iframe');
                const currentSrc = iframe.attr('src');
                const newSrc = currentSrc + '&autoplay=1&playsinline=1&mute=1&enablejsapi=1';
                // 使用延迟加载确保 iframe 已经完全加载
                setTimeout(() => {
                  iframe.attr('src', newSrc);
                  try {
                    const iframeElement = iframe[0];
                    iframeElement.contentWindow.postMessage(
                      JSON.stringify({
                        event: 'command',
                        func: 'playVideo',
                      }),
                      '*',
                    );
                  } catch (error) {
                    console.error('Failed to post play message:', error);
                  }
                }, 0);

                // 添加移动端点击播放/暂停功能
                _this.initMobileYouTubeControl(container);
              },
              onClose: (container) => {
                const iframe = $(container).find('iframe');
                const currentSrc = iframe.attr('src');
                iframe.attr('src', currentSrc.replace('&autoplay=1&playsinline=1&mute=1&enablejsapi=1', ''));
                $(this).off('click', this.handlePlayClick.bind(this));
              },
            });
          }
          this.modalManager.open(modalId);
        }

        initMobileYouTubeControl(container) {
          const $container = $(container);
          const iframe = $container.find('iframe')[0];
          let isMobile = window.innerWidth <= 768;
          let isPlaying = true; // 初始状态为播放

          // 检测是否为移动设备
          const checkMobile = () => {
            isMobile = window.innerWidth <= 768;
          };

          window.addEventListener('resize', checkMobile);

          // 添加点击事件监听器到iframe容器
          $container.on('click', (e) => {
            if (!isMobile) return;

            e.preventDefault();
            e.stopPropagation();

            try {
              if (isPlaying) {
                // 暂停视频
                iframe.contentWindow.postMessage(
                  JSON.stringify({
                    event: 'command',
                    func: 'pauseVideo',
                  }),
                  '*',
                );
                isPlaying = false;
              } else {
                // 播放视频
                iframe.contentWindow.postMessage(
                  JSON.stringify({
                    event: 'command',
                    func: 'playVideo',
                  }),
                  '*',
                );
                isPlaying = true;
              }
            } catch (error) {
              console.error('Failed to control YouTube video:', error);
            }
          });

          // 添加触摸事件支持（移动端）
          $container.on('touchend', (e) => {
            if (!isMobile) return;

            e.preventDefault();
            e.stopPropagation();

            try {
              if (isPlaying) {
                // 暂停视频
                iframe.contentWindow.postMessage(
                  JSON.stringify({
                    event: 'command',
                    func: 'pauseVideo',
                  }),
                  '*',
                );
                isPlaying = false;
              } else {
                // 播放视频
                iframe.contentWindow.postMessage(
                  JSON.stringify({
                    event: 'command',
                    func: 'playVideo',
                  }),
                  '*',
                );
                isPlaying = true;
              }
            } catch (error) {
              console.error('Failed to control YouTube video:', error);
            }
          });

          // 监听YouTube播放状态变化
          window.addEventListener('message', (event) => {
            if (event.origin !== 'https://www.youtube.com') return;

            try {
              const data = JSON.parse(event.data);
              if (data.event === 'video-progress') {
                // YouTube视频状态更新
                if (data.info && data.info.playerState !== undefined) {
                  isPlaying = data.info.playerState === 1; // 1 = 播放中
                }
              }
            } catch (error) {
              // 忽略解析错误
            }
          });
        }
      },
    );
  }
});
